import * as React from 'react';

import {getLocalizedText, texts} from '../../../constants/TextConst';
import {Button, Flex, Icon, PriorityIcon, Separator} from '@priority-software/priority-style-react';
import {MenuIcon} from './Menus/MenuIcon';
import BreadCrumbs from './BreadCrumbs/BreadCrumbs';
import {HeaderHelpButton} from '../../../_shared/Help/components/FormHelpUI';
import {isRTL} from '../../../Localization';

export const PopupHeaderFirstSection = props => {
    const {getZoomFieldValue, breadCrumbs, procEntity, getIsAppend, getDocName, isQuickSearch} =
        props;
    let lastParentIndex = 0;
    for (let i = 0; i < breadCrumbs.length; i++) {
        if (breadCrumbs[i].level === 0) {
            lastParentIndex = i;
        }
    }

    const popupCrumb = breadCrumbs[lastParentIndex];
    const restOfCrumbs = breadCrumbs.slice(lastParentIndex + 1, breadCrumbs.length);
    if (isQuickSearch && isQuickSearch()) {
        return <BreadCrumbs breadCrumbs={breadCrumbs} {...procEntity} />;
    }

    if (getIsAppend && getIsAppend()) {
        return (
            <span className="popup-title single">
                {getLocalizedText(texts.addItem)} {getDocName && getDocName()}
            </span>
        );
    }

    return (
        <React.Fragment>
            <span
                className={`popup-title ${restOfCrumbs.length === 0 && 'single'}`}
                onClick={e => popupCrumb.handleBreadCrumbClick(e, popupCrumb.menuButton)}
            >
                {getZoomFieldValue && getZoomFieldValue()}
            </span>
            {restOfCrumbs.length > 0 && (
                <Icon
                    icon={isRTL() ? PriorityIcon.arrowLeft : PriorityIcon.arrowRight}
                    iconColor="secondary-400"
                    componentClasses="crumbs-separator"
                />
            )}
            <BreadCrumbs breadCrumbs={restOfCrumbs} {...procEntity} />
        </React.Fragment>
    );
};

export const PopupTopHeaderPanel = ({topMenu, isRTL}) => {
    return (
        <section className="upper-section popup-top">
            <div className="popup-top-section">
                <div
                    className="buttons back-to-list"
                    onClick={topMenu.closeButton && topMenu.closeButton.action}
                >
                    <Button
                        size="small"
                        icon={isRTL ? PriorityIcon.arrowRight : PriorityIcon.arrowLeft}
                        componentClasses="back-button"
                    />
                    <div className="back-title">{getLocalizedText(texts.backtoList)}</div>
                </div>

                <Flex componentClasses="actions-button" justifyContent="flex-end">
                    <HeaderHelpButton tooltipPosition={'bottom-end'} />
                    <Separator align="horizontal" height={20} />
                    <MenuIcon name="collapse-icon" item={topMenu.closeButton} />
                </Flex>
            </div>
        </section>
    );
};
